module.exports = __webpack_public_path__ + "img/logo.a297aac4.png";